import React, { PureComponent } from 'react';

const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const pinStyle = {
    cursor: 'pointer',
    fill: '#fff',
    stroke: 'none'
};

const notRatedColor = '#fff'
const colors = ['#6f42c1', '#17a2b8', '#20c997', '#ffc107', '#fd7e14', '#dc3545'];

export default class ItemPin extends PureComponent {
    constructor() {
        super();
        this.getColor = this.getColor.bind(this);
    }

    getColor(rate) {
        if (!rate)
            return notRatedColor;

        return colors[rate];
    }

    render() {
        var { size = 24, onClick, rate } = this.props;
        const color = this.getColor(rate);
        var opacity = 1;

        if (!rate || rate == 0) {
            opacity = .5;
            rate = '';
        }

        return (
            <div
                style={{
                    width: 30,
                    height: 30,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer'
                }}
                onClick={onClick}>
                <svg
                    height={size}
                    viewBox="0 0 24 24"
                    style={{
                        ...pinStyle,
                        fill: `${color}`,
                        opacity: `${opacity}`
                    }}
                >
                    <path d={ICON} />
                </svg>
                <div
                    style={{
                        width: '100%',
                        textAlign: 'center',
                        position: 'absolute',
                        bottom: '7px',
                        color: 'white',
                        fontWeight: 'bold'
                    }}>{rate}</div>
            </div >
        );
    }
}
